export const getLineItemGeneration = (lineItem) => {
  const generationId = lineItem?.active_generation_id
    || lineItem?.generation_id;

  if (!generationId) {
    return null;
  }

  return {
    ...(lineItem.generation || {}),
    generation_id: generationId,
    status: lineItem.generation?.status
      || lineItem.generation_status
      || lineItem.status
  };
};
